import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store';
import ValidationPlugin from './plugins/validation.plugin.js'
import HelperPlugin from "./plugins/helper.plugin";
import VueCustomElement from 'vue-custom-element';
import 'document-register-element/build/document-register-element';

Vue.config.productionTip = false

Vue.use(ValidationPlugin);
Vue.use(HelperPlugin);
Vue.use(VueCustomElement);

App.vuetify = vuetify;
App.store = store;

Vue.customElement('pore-kaukolampolaskuri', App);
